var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('hero'),_c('mobile-title'),_c('how-it-works'),_c('steps-explanation'),_c('design-your-own'),_c('div',{staticClass:"col-12"},[_c('popular-posts')],1),_c('jeweler-ai-banner'),_c('find-jeweler'),_c('router-view'),_c('successfully-loaded')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }